/* eslint react/prop-types: 0 */
import React from 'react';
import { Route } from 'react-router-dom';
import PaymentDashboard from './PaymentDashboard';

const PaymentRouter = () => {
  return (
    <>
      <Route exact path="/UPY0" component={PaymentDashboard} />
      {/* <Route exact path="/UPY1" component={PaymentList} /> */}
    </>
  );
};

export default PaymentRouter;
